import React, { useEffect, useRef } from 'react';
import SelectButtonList from '../SelectButtonList/SelectButtonList';
import { useClickAwayClose } from  '@/components/hooks/utility/useClickAwayClose';
import { ISelectButton } from  '@/interfaces/selectButtonList';
import useParentBlurListener from  '@/components/hooks/utility/useParentBlur';

interface IFixedPositionContextMenu {
    anchorButton:JSX.Element, 
    closeOnScrollTarget?:string, 
    containerQuerySelector?: string, 
    menuButtons: ISelectButton[],
    controlIsOpen: boolean,
    setControlIsOpen: (val: boolean) => void,
    className?:string,
    manualOffset?:{top?: number, right?:number}
}



const FixedPositionContextMenu = ({anchorButton, closeOnScrollTarget, containerQuerySelector, menuButtons, controlIsOpen, className, setControlIsOpen, manualOffset}: IFixedPositionContextMenu) => {
    const containerRef = useRef<HTMLDivElement>();
    const modalRect = containerQuerySelector 
        ? document.querySelector(containerQuerySelector).getBoundingClientRect()
        : document.body.getBoundingClientRect()
    let {top, height, right} = containerRef.current  ? containerRef.current.getBoundingClientRect() : {top: 0}
    

    useClickAwayClose(controlIsOpen, containerRef, closeMenu);

    useParentBlurListener(containerRef, closeMenu);
    
    useEffect(() => {
        closeOnScrollTarget && document.querySelector(closeOnScrollTarget).addEventListener('scroll', closeMenu);
        document.body.addEventListener('scroll', closeMenu, true)
        return () => { 
            closeOnScrollTarget && document?.querySelector(closeOnScrollTarget)?.removeEventListener('scroll', closeMenu);
            document.body.addEventListener('scroll', closeMenu)
        };
    },[])

    function closeMenu() {
        setControlIsOpen(false);
    }

    function getRightPos(){
        return modalRect.left + (manualOffset?.right || 0)
    }

    function getTopPos() {
        return top + height + (manualOffset?.top || 0);
    }
    
    return (
        <div className={`edit-permissions-control ${className}`} ref={containerRef}>
            {anchorButton}

            {controlIsOpen && <SelectButtonList className="simple-controls drag-and-drop-list" buttons={menuButtons} allButtonOnClick={()=> setControlIsOpen(false)} fixedPosition={{top: getTopPos(), right: getRightPos()}} />}
        </div>
    )
}

export default FixedPositionContextMenu